import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-50">
                炽热之夜
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              专注菲律宾优质电影内容的华语影迷社区，为您带来最深度、最专业的菲律宾电影资讯与评论。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line"></i>
                <span>contact@chirezhizhiye.ph</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-wechat-line"></i>
                <span>chirezhizhiye_film</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-weibo-line"></i>
                <span>@炽热之夜电影资讯站</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 炽热之夜电影资讯站. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供影迷交流参考，不提供影片下载或盗版资源。
          </p>
        </div>
      </div>
    </footer>
  );
}